import React from "react";
import { CanvasSoldLabel } from "./CanvasSoldLabel";

export function CanvasArtworkTitleRow({
  title,
  sold,
  as: Tag = "h3",
  className = "font-display text-xl font-medium text-canvas-950",
}: {
  title: string;
  sold?: boolean;
  as?: "h2" | "h3";
  className?: string;
}) {
  return (
    <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
      <Tag className={className}>{title}</Tag>
      {sold && <CanvasSoldLabel />}
    </div>
  );
}
